import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import EventListChat from "./EventListChat";
import EventListParticipant from "./EventListParticipant";

const EventListTabs = (props) => {
  const { eventId, tabType } = useParams();
  const { module } = props;
  const userTabs = useMemo(
    () => ({
      chats: "Chats",
      participants: "Participants",
    }),
    []
  );

  const [ToggleState, setToggleState] = useState();

  useEffect(() => {
    setToggleState(userTabs?.[tabType] ? tabType : "chats");
  }, [tabType, userTabs]);

  return (
    <Box className="managepro6ix-layout-page-content">
      <div className="managepro6ix-layout-page-content-header">
        <div className="managepro6ix-layout-page-content-header-left">
          <div className="managepro6ix-layout-page-content-header-menu">
            {Object.keys(userTabs).map((item, key) => (
              <Link
                key={key}
                to={`/events/list/${eventId}/${item}`}
                className={`managepro6ix-layout-page-content-header-menu-link ${
                  ToggleState === item ? "active" : ""
                }`}
              >
                {userTabs[item]}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {ToggleState === "chats" ? (
        <EventListChat />
      ) : ToggleState === "participants" ? (
        <EventListParticipant module={module} />
      ) : null}
    </Box>
  );
};

export default EventListTabs;
